<template>
  <div>
    <v-dialog v-model="openDialog" max-width="600" persistent>
      <v-card>
        <v-card-title>
          Nouveau Supplier
          <v-spacer />
          <v-btn icon class="v-btn--active" color="primary" @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <form @submit.prevent="send">
            <h3 class="">Information Supplier</h3>
            <v-text-field
              label="Désignation *"
              @input="
                formErrors && formErrors.name ? (formErrors.name = '') : false
              "
              :error-messages="
                formErrors && formErrors.name ? formErrors.name[0] : ''
              "
              v-model="form.name"
            />
            <div class="d-flex align-center">
              <v-file-input
                label="Icone *"
                accept="image/png, image/jpeg, image/jpg, .svg, .gif"
                show-size
                suffix="Image"
                @change="uploadFile"
                @focus="
                  formErrors && formErrors.image
                    ? (formErrors.image = '')
                    : false
                "
                ref="fileImage"
                chips
                prepend-icon="mdi-camera"
                :error-messages="formErrors.image"
              />
              <v-btn
                depressed
                icon
                small
                class="primary white--text ml-2"
                v-if="form.image"
                @click="previewImage(form.image)"
              >
                <v-icon small>mdi mdi-eye</v-icon>
              </v-btn>
            </div>

            <h3 class="mt-4">Information utilisateur</h3>

            <v-text-field
              label="Nom Utilsaeur *"
              @input="
                formErrors && formErrors.user_name
                  ? (formErrors.user_name = '')
                  : false
              "
              :error-messages="
                formErrors && formErrors.user_name
                  ? formErrors.user_name[0]
                  : ''
              "
              v-model="form.user_name"
            />

            <v-text-field
              label="Pseudo *"
              @input="
                formErrors && formErrors.user_pseudo
                  ? (formErrors.user_pseudo = '')
                  : false
              "
              :error-messages="
                formErrors && formErrors.user_pseudo
                  ? formErrors.user_pseudo[0]
                  : ''
              "
              v-model="form.user_pseudo"
            />

            <v-text-field
              label="Email *"
              type="email"
              @input="
                formErrors && formErrors.user_email
                  ? (formErrors.user_email = '')
                  : false
              "
              :error-messages="
                formErrors && formErrors.user_email
                  ? formErrors.user_email[0]
                  : ''
              "
              v-model="form.user_email"
            />

            <v-text-field
              label="Telephone *"
              @input="
                formErrors && formErrors.user_phone
                  ? (formErrors.user_phone = '')
                  : false
              "
              :error-messages="
                formErrors && formErrors.user_phone
                  ? formErrors.user_phone[0]
                  : ''
              "
              v-model="form.user_phone"
            />

            <v-text-field
              label="Mot de passe *"
              @input="
                formErrors && formErrors.user_password
                  ? (formErrors.user_password = '')
                  : false
              "
              :error-messages="
                formErrors && formErrors.user_password
                  ? formErrors.user_password[0]
                  : ''
              "
              v-model="form.user_password"
              :type="show ? 'text' : 'password'"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show = !show"
            />

            <v-text-field
              label="Confirmation du Mot de passe *"
              @input="
                formErrors && formErrors.user_password_confirmation
                  ? (formErrors.user_password_confirmation = '')
                  : false
              "
              :error-messages="
                formErrors && formErrors.user_password_confirmation
                  ? formErrors.user_password_confirmation[0]
                  : ''
              "
              v-model="form.user_password_confirmation"
              :type="show ? 'text' : 'password'"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show = !show"
            />

            <v-btn
              color="primary"
              class="rounded-lg text-none mt-3"
              :loading="btnLoading"
              large
              depressed
              @click="send"
            >
              <v-icon left>mdi-send-outline</v-icon>
              Savegarder
            </v-btn>
          </form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import { HTTP } from "@/http-common";

export default {
  data() {
    return {
      btnLoading: false,
      show: false,
      formErrors: {},
      form: {
        name: "",
        image: "",
      },
      openDialog: false,
    };
  },

  computed: {},
  methods: {
    open() {
      this.openDialog = true;
    },
    close() {
      //this.$emit("update:openDialog", false);
      this.openDialog = false;
    },
    send() {
      this.btnLoading = true;

      let formData = new FormData();
      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key]);
      });

      HTTP.post("/manager/vouchers/suppliers/create", formData, { params: {} })
        .then(() => {
          this.$successMessage = "Ce Supplier a été crée avec succès";
          this.btnLoading = false;
          this.close();
          this.form = {};
          this.$refs.fileImage.reset();

          this.openDialog = false;
          this.$emit("refresh");
        })
        .catch((err) => {
          this.btnLoading = false;
          this.formErrors = err.response.data.errors;
        });
    },

    uploadFile(file) {
      this.form.image = file;
      console.log("icon changed");
    },
  },
  created() {},
};
</script>
  
  